export default __webpack_public_path__ + "images/1d354827e66a5f84792f8f5f123049d2-accord.svg";